import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const departments = [
  { value: 'ventas', label: 'Ventas' },
  { value: 'compras', label: 'Compras' },
  { value: 'contraloría', label: 'Contraloría' },
  { value: 'dirección general', label: 'Dirección General' },
  { value: 'bodega', label: 'Bodega' },
  { value: 'seguridad', label: 'Seguridad' }
];

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const trimmedUsername = username.trim();
    const trimmedPassword = password.trim();
    
    if (!trimmedUsername || !trimmedPassword) {
      return;
    }

    setLoading(true);
    
    const result = await login(trimmedUsername, trimmedPassword);
    if (result.success) {
      // Redirect based on user role
      if (result.user.role === 'security') {
        navigate('/security');
      } else {
        navigate('/admin');
      }
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container" data-testid="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1 data-testid="login-title">
            Control de Accesos HVGC
          </h1>
          <p className="login-subtitle">
            Sistema de Gestión de Visitantes
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuario</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingrese su usuario"
              data-testid="username-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese su contraseña"
              data-testid="password-input"
              required
            />
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={loading}
            data-testid="submit-btn"
          >
            {loading ? 'Procesando...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;